import { twMerge } from "tailwind-merge";
import { forwardRef } from "react";
import { TableHeaderBase, type TableHeaderBaseProps } from "@core/ui";

export type Props = Omit<TableHeaderBaseProps, "data-testid">;

/**
 * Styled table header section wrapping TableHeaderBase.
 */
export const TableHeader = forwardRef<HTMLTableSectionElement, Props>(
  ({ className, ...props }, ref) => {
    return (
      <TableHeaderBase
        ref={ref}
        className={twMerge(
          "hidden bg-brand-100 md:table-header-group",
          className
        )}
        data-testid="table-header"
        {...props}
      />
    );
  }
);

TableHeader.displayName = "TableHeader";

export default TableHeader;

